import { formatDate } from "../../shared/utility";
import { openAppPathInNewTab } from "../../views/dashboard/dashboardHelpers";
import {
  formatCreditStatus,
  formatShipmentStatus,
  getCreditStatusBadgeClass,
  getShipmentActionLabel,
  getShipmentStatusBadgeClass,
  formatCases,
} from "../../views/orders/orderDetailsHelpers";

export default function OrderShipmentsTable(props) {
  const {
    shipments = [],
    createShipmentFromOrder,
    canCreateShipment,
    loading,
  } = props;

  const handleCreateShipment = () => {
    if (canCreateShipment && createShipmentFromOrder) {
      createShipmentFromOrder();
    }
  };

  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="flex flex-col gap-3 border-b border-slate-200 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h2 className="text-base font-semibold text-slate-900">
            Shipments Attached to This Order
          </h2>
          <p className="mt-1 text-sm text-slate-500">
            View fulfillment, shipped cartons, returns, and credits for this
            order.
          </p>
        </div>

        <button
          type="button"
          onClick={handleCreateShipment}
          disabled={!canCreateShipment || loading}
          title={
            canCreateShipment
              ? undefined
              : "Shipment cannot be created for this order status."
          }
          className="rounded-xl bg-main-purple px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-600 disabled:cursor-not-allowed disabled:opacity-50"
        >
          Create Shipment
        </button>
      </div>

      {shipments.length === 0 ? (
        <div className="px-5 py-8 text-center">
          <p className="text-sm font-semibold text-slate-900">
            No shipments have been created for this order yet.
          </p>
          <p className="mt-1 text-sm text-slate-500">
            Create a shipment when the warehouse is ready to pick and ship this
            order.
          </p>
          <button
            type="button"
            onClick={handleCreateShipment}
            disabled={!canCreateShipment || loading}
            className="mt-4 rounded-xl bg-main-purple px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-600 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Create First Shipment
          </button>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-blue-50 text-slate-800">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  Shipment #
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  Created
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  Shipped
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  Cases
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  Returned
                </th>
                <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">
                  Credit
                </th>
                <th className="px-4 py-3 text-right text-xs font-semibold uppercase tracking-wide">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {shipments.map((shipment) => (
                <tr
                  key={shipment.id}
                  className="border-t border-slate-200 hover:bg-slate-50"
                >
                  <td className="px-4 py-3 font-semibold text-slate-900">
                    {shipment.shipping_number || `SHP-${shipment.id}`}
                  </td>
                  <td className="px-4 py-3">
                    <span
                      className={getShipmentStatusBadgeClass(shipment.status)}
                    >
                      {formatShipmentStatus(shipment.status)}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-slate-600">
                    {shipment.created_at
                      ? formatDate(shipment.created_at)
                      : "-"}
                  </td>
                  <td className="px-4 py-3 text-slate-600">
                    {shipment.shipped_date
                      ? formatDate(shipment.shipped_date)
                      : "-"}
                  </td>
                  <td className="px-4 py-3 text-slate-900">
                    {formatCases(
                      shipment.shipped_cases ??
                        shipment.total_cases ??
                        0
                    )}
                  </td>
                  <td className="px-4 py-3 text-slate-900">
                    {formatCases(shipment.returned_cases ?? 0)}
                  </td>
                  <td className="px-4 py-3">
                    <span
                      className={getCreditStatusBadgeClass(
                        shipment.credit_status
                      )}
                    >
                      {formatCreditStatus(shipment.credit_status)}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button
                      type="button"
                      onClick={() =>
                        openAppPathInNewTab(`/shippings/${shipment.id}`)
                      }
                      className="rounded-lg bg-slate-100 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-200"
                    >
                      {getShipmentActionLabel(shipment.status)}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
